import { render, staticRenderFns } from "./invproreport.vue?vue&type=template&id=5820d075&scoped=true&"
import script from "./invproreport.vue?vue&type=script&lang=js&"
export * from "./invproreport.vue?vue&type=script&lang=js&"
import style0 from "./invproreport.vue?vue&type=style&index=0&id=5820d075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820d075",
  null
  
)

export default component.exports